enum DriverAddAddressType {
  MAILING = "MAILING",
  STARTING = "STARTING",
}

export default DriverAddAddressType;
